export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9378.7d49b6c8.jpg";